export default {
    'warehouses-statistics': 'إحصائيات المستودع',
    'materials-statement': 'كشف مواد',
    'material-stock-limit': 'حد مخزون المواد',
    'materials-stock-by-city-statistics': 'مخزون المواد'
}